// function App() {
//     const [error, setError] = useState(null);
//     const [isLoaded, setIsLoaded] = useState(false);
//     const [items, setItems] = useState([]);
//     //     set search query to empty string
//     const [q, setQ] = useState("");
//     //     set search parameters
//     //     we only what to search countries by capital and name
//     //     this list can be longer if you want
//     //     you can search countries even by their population
//     // just add it to this array
//     const [searchParam] = useState(["capital", "name"]);
//     //     add a default value to be used by our select element
//     const [filterParam, setFilterParam] = useState(["All"]);

import {
  Autocomplete,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  Paper,
  Select,
  TextField,
} from "@mui/material";

//     // Note: the empty deps array [] means
//     // this useEffect will run once
//     // similar to componentDidMount()
//     useEffect(() => {
//         fetch("https://restcountries.eu/rest/v2/all")
//             .then((res) => res.json())
//             .then(
//                 (result) => {
//                     setIsLoaded(true);
//                     setItems(result);
//                 },

//                 // Note: it's important to handle errors here
//                 // instead of a catch() block so that we don't swallow
//                 // exceptions from actual bugs in components.
//                 (error) => {
//                     setIsLoaded(true);
//                     setError(error);
//                 }
//             );
//     }, []);

//     /* here we create a function
// //     we filter the items
// // use array property .some() to return an item even if other requirements didn't match
//     */
//     function search(items) {
//         return items.filter((item) => {
//             /*
// //             in here we check if our region is equal to our c state
// // if it's equal to then only return the items that match
// // if not return All the countries
//             */
//             if (item.region == filterParam) {
//                 return searchParam.some((newItem) => {
//                     return (
//                         item[newItem]
//                             .toString()
//                             .toLowerCase()
//                             .indexOf(q.toLowerCase()) > -1
//                     );
//                 });
//             } else if (filterParam == "All") {
//                 return searchParam.some((newItem) => {
//                     return (
//                         item[newItem]
//                             .toString()
//                             .toLowerCase()
//                             .indexOf(q.toLowerCase()) > -1
//                     );
//                 });
//             }
//         });
//     }

//     if (error) {
//         return (
//             <p>
//                 {error.message}, if you get this error, the free API I used
//                 might have stopped working, but I created a simple example that
//                 demonstrate how this works,{" "}
//                 <a href="https://codepen.io/Spruce_khalifa/pen/mdXEVKq">
//                     {" "}
//                     check it out{" "}
//                 </a>{" "}
//             </p>
//         );
//     } else if (!isLoaded) {
//         return <>loading...</>;
//     } else {
//         return (
//             <div className="wrapper">
//                 <div className="search-wrapper">
//                     <label htmlFor="search-form">
//                         <input
//                             type="search"
//                             name="search-form"
//                             id="search-form"
//                             className="search-input"
//                             placeholder="Search for..."
//                             value={q}
//                             /*
//                             // set the value of our useState e
//                             //  anytime the user types in the search box
//                             */
//                             onChange={(e) => setQ(e.target.value)}
//                         />
//                         <span className="sr-only">Search countries here</span>
//                     </label>

//                     <div className="select">
//                         <select
//                             /*
// //                         here we create a basic select input
// //                     we set the value to the selected value
// //                     and update the setC() state every time onChange is called
//                     */
//                             onChange={(e) => {
//                                 setFilterParam(e.target.value);
//                             }}
//                             className="custom-select"
//                             aria-label="Filter Countries By Countries"
//                         >
//                             <option value="All">Filter By Region</option>
//                             <option value="Africa">Africa</option>
//                             <option value="Americas">America</option>
//                             <option value="Asia">Asia</option>
//                             <option value="Europe">Europe</option>
//                             <option value="Oceania">Oceania</option>
//                         </select>
//                         <span className="focus"></span>
//                     </div>
//                 </div>
//                 <ul className="card-grid">
//                     {search(items).map((item) => (
//                         <li>
//                             <article className="card" key={item.id}>
//                                 <div className="card-image">
//                                     <img src={item.flag} alt={item.name} />
//                                 </div>
//                                 <div className="card-content">
//                                     <h2 className="card-name">{item.name}</h2>
//                                     <ol className="card-list">
//                                         <li>
//                                             population:{" "}
//                                             <span>{item.population}</span>
//                                         </li>
//                                         <li>
//                                             Region: <span>{item.region}</span>
//                                         </li>
//                                         <li>
//                                             Capital: <span>{item.capital}</span>
//                                         </li>
//                                     </ol>
//                                 </div>
//                             </article>
//                         </li>
//                     ))}
//                 </ul>
//             </div>
//         );
//     }
// }

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Card, Input } from "semantic-ui-react";
// import { IconButton, TextField } from "@mui/material";
// export default function Posts() {
//   const [APIData, setAPIData] = useState([]);
//   const [filteredResults, setFilteredResults] = useState([]);
//   const [searchInput, setSearchInput] = useState("");
//   useEffect(() => {
//     axios.get(`https://jsonplaceholder.typicode.com/users`).then((response) => {
//       setAPIData(response.data);
//     });
//   }, []);

//   const searchItems = (searchValue) => {
//     setSearchInput(searchValue);
//     if (searchInput !== "") {
//       const filteredData = APIData.filter((item) => {
//         return Object.values(item)
//           .join("")
//           .toLowerCase()
//           .includes(searchInput.toLowerCase());
//       });
//       setFilteredResults(filteredData);
//     } else {
//       setFilteredResults(APIData);
//     }
//   };

//   return (
//     <div style={{ padding: 20 }}>
//       <Input
//         icon="search"
//         placeholder="Search..."
//         onChange={(e) => searchItems(e.target.value)}
//       />
//       <Card.Group itemsPerRow={3} style={{ marginTop: 20 }}>
//         {searchInput.length > 1
//           ? filteredResults.map((item) => {
//               return (
//                 <Card>
//                   <Card.Content>
//                     <Card.Header>{item.name}</Card.Header>
//                     <Card.Description>{item.email}</Card.Description>
//                   </Card.Content>
//                 </Card>
//               );
//             })
//           : APIData.map((item) => {
//               return (
//                 <Card>
//                   <Card.Content>
//                     <Card.Header>{item.name}</Card.Header>
//                     <Card.Description>{item.email}</Card.Description>
//                   </Card.Content>
//                 </Card>
//               );
//             })}
//       </Card.Group>
//     </div>
//   );
// }
import SearchIcon from "@mui/icons-material/Search";
import { generateSingleOptions } from "../../FormComponent/FormInputDropdown";
import { optionsUserCategory } from "../../../select-options/options";
import { Controller, useForm } from "react-hook-form";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";

export const SearchBar = ({ setZipData, zipData }) => {
  const navigate = useNavigate();
  return (
    <Box sx={{ my: 3 }}>
      <TextField
        // id="outlined-basic"
        label="Zip Code"
        variant="outlined"
        // fullWidth
        type={"number"}
        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
        size={"small"}
        name="zip_code"
        sx={[
          (theme) => ({
            [theme.breakpoints.down("sm")]: {
              width: "80%",
              // py: 3,
              // px: 1,
              // mx: 1,
            },
          }),
        ]}
        // onChange={(e)=> handleSubmits(e)}
        onChange={(e) => setZipData(e.target.value)}
        helperText={zipData?.errors && zipData?.errors?.zip_code}
      />
      {zipData !== "" && (
        <IconButton
          onClick={() =>
            navigate(`/dashboard/find-job/zip_code?query=${zipData}`)
          }
          aria-label="search"
        >
          {" "}
          <SearchIcon style={{ fill: "blue" }} />
        </IconButton>
      )}

      {/* <TextField
        id="search-bar"
        className="text"
        //   onInput={(e) => {
        //     setSearchQuery(e.target.value);
        //   }}
        onChange={(e) => searchItems(e.target.value)}
        label="Enter zip code"
        variant="outlined"
        placeholder="Search..."
        size="small"
      /> */}
    </Box>
  );
};

export const FilteredByCategories = ({ categoryData, setCategoryData }) => {
  // const searchItems = (searchValue) => {
  //   setSearchInput(searchValue);
  //   if (searchInput !== "") {
  //     const filteredData = APIData.filter((item) => {
  //       return Object.values(item)
  //         .join("")
  //         .toLowerCase()
  //         .includes(searchInput.toLowerCase());
  //     });
  //     setFilteredResults(filteredData);
  //   } else {
  //     setFilteredResults(APIData);
  //   }
  // };
  const navigate = useNavigate();
  const onSubmit = async (data) => {
    console.log("cate");
    if (data.job_categories !== "") {
      console.log(data.job_categories);
    } else if (data.zip_code) {
      console.log(data.zip_code);
    }
    console.log(data);
  };

  return (
    <>
      <Box sx={{ mb: 4 }}>
        <FormControl
          // error={Boolean(errors.job_categories)}
          // helperText={errors.user_type?.message}
          size={"small"}
          sx={[
            { width: "30%" },
            (theme) => ({
              [theme.breakpoints.down("md")]: {
                width: "40%",
                // py: 3,
                // px: 1,
                // mx: 1,
              },
            }),
            (theme) => ({
              [theme.breakpoints.down("sm")]: {
                width: "80%",
                // py: 3,
                // px: 1,
                // mx: 1,
              },
            }),
          ]}
        >
          <InputLabel> Find by categories?</InputLabel>

          <Select
            required
            value={categoryData}
            onChange={(e) => setCategoryData(e.target.value)}
          >
            {generateSingleOptions(optionsUserCategory)}
          </Select>

          {/* <Select>{generateSingleOptions(optionsUserCategory)}</Select> */}
          {/* <FormHelperText>{errors.job_categories?.message}</FormHelperText> */}
        </FormControl>
        {categoryData !== "" && (
          <IconButton
            onClick={() =>
              navigate(
                `/dashboard/find-job/categories?categories=${categoryData}`
              )
            }
            aria-label="search"
          >
            {" "}
            <SearchIcon style={{ fill: "blue" }} />
          </IconButton>
        )}
      </Box>
    </>
  );
};
